import PropArray from "../../../type/propArray"
import useDiscard from "../../../useDiscard";
import useWeakMap from "../../../utils/useWeakMap"
import { useQueryOriginSource } from "../useQueryOriginal";
import { isLayer } from "../validator/useLayerIdentity"

const store = useWeakMap()
const storeByOriginalSource = useWeakMap();

const onDiscardLayer = (layer) => {
    store.delete(layer);
    const originalSource = useQueryOriginSource(layer);
    if (originalSource) {
        storeByOriginalSource.get(originalSource).delete(layer);
    }
}

export const storePathByLayer = (layer, paths) => {
    if (!isLayer(layer)) '"layer" is not a Layer'
    if (!(paths instanceof PropArray)) '"paths" is not instanceof PropArray';
    paths = paths.clone();
    if (!store.has(layer)) {
        useDiscard(layer, onDiscardLayer);
    }

    store.set(layer, paths);

    const originalSource = useQueryOriginSource(layer);
    if (originalSource && !storeByOriginalSource.has(originalSource)) {
        storeByOriginalSource.set(originalSource, new Map());
    }

    storeByOriginalSource.get(originalSource).set(layer, paths);

}

/**
 * 
 * @param {Object} layer 
 * @returns {PropArray |  undefined}
 */
const useQueryPathByLayer = (layer) => {
    return store.get(layer).clone();
}

/**
 * 
 * @param {object} source 
 * @returns {Map<object, PropArray>}
 */
export const useQueryPathsByOriginalSource = (source) => {
    return storeByOriginalSource.get(source);
}

const deletePathByLayer = (layer) => {
    store.delete(layer);
    const originalSource = useQueryOriginSource(layer);
    if (originalSource && storeByOriginalSource.has(originalSource)) {
        storeByOriginalSource.get(originalSource).delete(layer);
    }
}

export const swapPathByLayer = (layer, newPropPath) => {
    deletePathByLayer(layer);
    storePathByLayer(layer, newPropPath);
}

export default useQueryPathByLayer